import script from "./page-1.vue?vue&type=script&setup=true&lang=js"
export * from "./page-1.vue?vue&type=script&setup=true&lang=js"

import "./page-1.vue?vue&type=style&index=0&id=ead09642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ead09642"]])

export default __exports__